import { render, staticRenderFns } from "./shangwushujupage.vue?vue&type=template&id=44fdc963&scoped=true"
import script from "./shangwushujupage.vue?vue&type=script&lang=js"
export * from "./shangwushujupage.vue?vue&type=script&lang=js"
import style0 from "./shangwushujupage.vue?vue&type=style&index=0&id=44fdc963&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fdc963",
  null
  
)

export default component.exports